/**
 * Fast hash function to create a hash from a string
 * Used to detect if configuration has changed
 *
 * Uses DJB2-like algorithm with bitwise optimization for 32-bit integer conversion.
 * For very long strings, samples characters to improve performance while maintaining
 * good collision resistance.
 */
export const simpleHash = (str: string): string => {
    let hash = 5381 // DJB2 initial value

    // For very long strings (>1000 chars), sample every 3rd character for performance
    const skip = str.length > 1000 ? 3 : 1

    for (let i = 0; i < str.length; i += skip) {
        // Bitwise shift and add: equivalent to hash * 33 + char
        hash = (hash << 5) + hash + str.charCodeAt(i)
        // Bitwise AND with 0x7FFFFFFF to ensure positive 32-bit integer
        hash = hash & 0x7fffffff
    }

    return hash.toString(36)
}
